import currency from 'currency.js';

export const EURO = (value: any) => currency(value, { symbol: '€', decimal: ',', separator: '.', pattern: '! #' }).format();